/**
 * Возвращает смещение временной зоны в часах.
 * Например, Москва +3, Екатеринбург +5.
 */
export const getTimezone = () => {
    return new Date().getTimezoneOffset() / -60
}
